<template lang="pug">
#app( :class='classes' )
  transition( name='fade' mode='out-in' appear )
    component.body-wrap.wrapper(
      :is='layoutComponent'
      :key='layout'
      v-bind='{ noHeader, noFooter, noScroll }'
    )
      router-view
  transition( name='fade' )
    d-loading( v-if='isMainLoading' :spinner-size='96' spinner-thickness='12px' )
  //- transition( name='fade' )
  //-   d-notice-full( v-if='notice' )
  //-     .content( v-html='notice' )
</template>

<script lang="js">
import get from 'lodash-es/get'
import { mapActions, mapState, mapGetters } from 'vuex'
import * as layouts from '@/layouts'
import DLoading from '@/displays/d-loading'
import api from '@/lib/wpapix'

export default {
  name: 'App',
  components: {
    ...layouts,
    DLoading,
  },
  data() {
    return {
      user: {},
      notice: 'We are in the process of reorganizing our website, so you will not be able to access our programmes at this time. BSH apologizes for the inconvenience caused and assure you that things will be back to normal shortly.'
    }
  },
  mounted() {
    this.hijackHrefs()
    const { notice } = this
    // this.openModal({ name: 'm-notice', data: { notice }})
  },
  created() {
    window.addEventListener( 'resize', this.handleResize )
    document.addEventListener( 'keydown', this.onKeydDown )
    this.startLoading( 'page' )
    this.onResize()
    // get basic models
    api.then(() => {
      this.getModelCollection({ model: 'Attachment_category' })
      this.getModelCollection({ model: 'Attachment_tag' })
      this.getModelCollection({ model: 'Collection' })
      this.getSettings()
      if ( this.$store.state.menus.nav ) {
        this.pushMenu({
          name: 'main-nav',
          items: this.$store.state.menus.nav,
        })
      }
    })
  },
  destroyed() {
    window.removeEventListener( 'resize', this.handleResize )
  },
  methods: {
    ...mapActions([
      'startLoading',
      'openModal',
      'closeModal',
      'closeSidebar',
      'getModelCollection',
      'getSettings',
      'pushMenu',
    ]),
    onResize() {
      this.$store.state.window.width = window.innerWidth
      this.$store.state.window.height = window.innerHeight
      // FIXME: use mutation
    },
    onKeydDown( $event ) {
      // for old browser support as a fallback
      if ( $event.key === 'Escape' || $event.key === 'Esc' ||
           $event.keyCode === 27 ) {
        this.closeModal()
        this.closeSidebar()
      }
    },
    hijackHrefs() {
      window.addEventListener( 'click', event => {
        const { target } = event
        // handle only links that do not reference external resources
        if ( target && target.matches( 'a:not([href*=\'://\'])' ) && target.href ) {
          // some sanity checks taken from vue-router:
          // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
          const {
            altKey,
            ctrlKey,
            metaKey,
            shiftKey,
            button,
            defaultPrevented
          } = event
          // don't handle with control keys
          if ( metaKey || altKey || ctrlKey || shiftKey ) return
          // don't handle when preventDefault called
          if ( defaultPrevented ) return
          // don't handle right clicks
          if ( button !== undefined && button !== 0 ) return
          // don't handle if `target="_blank"`
          if ( target && target.getAttribute ) {
            const linkTarget = target.getAttribute( 'target' )
            if ( /\b_blank\b/i.test( linkTarget )) return
          }
          // don't handle same page links/anchors
          const url = new URL(target.href)
          const to = url.pathname
          if ( window.location.pathname !== to && event.preventDefault ) {
            event.preventDefault()
            this.$router.push( to + url.search + url.hash )
          }
        }
      })
    }
  },
  beforeDestroy() {
    document.removeEventListener( 'keydown', this.onKeydDown )
  },
  provide() {
    return {
      layoutHeader: !this.noHeader,
      layoutFooter: !this.noFooter,
      layoutScroll: !this.noScroll,
    }
  },
  computed: {
    ...mapState([ 'loading' ]),
    ...mapGetters([ 'isMainLoading', 'layout' ]),
    layoutComponent () {
      return `l-${ this.layout }`
      // TODO: env var or setting for default layout
    },
    noHeader () {
      return get(this.$route, 'meta.noHeader')
    },
    noFooter () {
      return get(this.$route, 'meta.noFooter')
    },
    noScroll () {
      return get(this.$route, 'meta.noScroll')
    },
    classes() { return [] }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #ddeeff;
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  > .d-loading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background: var(--c-bg-loading, black);
    --c-loader: rgba(0,255,255,0.75);
    .spinner-frame {
      mix-blend-mode: difference;
    }
  }
}
</style>
